import React, { useEffect } from "react";
import ReactMarkdown from "react-markdown";
import { useQuery } from "react-query";
import styled from "styled-components";
import { getOneNewsItem } from "../../api/api";
import {
  GLOBAL_MEDIA_QUERIES,
  primaryColors,
  secondaryColors,
} from "../../constatnts";
import { ImagesEntity, INews } from "../../types/news";
import { useTranslation } from "react-i18next";
import { useMedia } from "react-media";
import { IMedia } from "../../types/types";
import { Helmet } from "react-helmet";
import InnerPageLayout from "../../Components/Layout/InnerPageLayout";
import { useParams } from "react-router-dom";
interface IProps {
  id?: string;
}
const NewsPage = (props: IProps) => {
  const matches = useMedia({ queries: GLOBAL_MEDIA_QUERIES });
  let { id } = useParams(); 

  const { t, i18n } = useTranslation();

  const { isLoading, error, data, isFetching, refetch }: any = useQuery(
    "newsData",
    () => getOneNewsItem({ id: id || "1", language: i18n.language })
  );

  useEffect(() => {
    refetch();
  }, [i18n.language]);
  if (isLoading) return <div></div>;

  if (error) return <div></div>;

  let newsItem: INews = data["data"];
  return (
    <InnerPageLayout>
      <>
        <Helmet>
          <title>{newsItem.Title}</title>
          <meta name="description" content={newsItem.SubTitle}></meta>
        </Helmet>
        <Container className="Container" {...matches}>
          <Content className="Content">
            <Title>{newsItem.Title}</Title>
            <SubTitle>{newsItem.SubTitle}</SubTitle>
            <ReactMarkdown>{newsItem.Content}</ReactMarkdown> <Spacer />
          </Content>

          <ImagesContainer className="ImagesContainer">
            {newsItem.Images.map((image: ImagesEntity) => (
              <Image
                src={`${process.env.REACT_APP_CMS}${image?.url}`}
                {...matches}
              />
            ))}
          </ImagesContainer>
        </Container>{" "}
      </>
    </InnerPageLayout>
  );
};
const Container = styled.div<IMedia>`
  padding: ${(props) => (props.large ? "30px 70px" : "10px 10px")};
  flex-direction: ${(props) => (props.large ? "row" : "column-reverse")};

  display: flex;

  position: relative;
  line-height: 1.5em;

  color: ${primaryColors[3]};
`;

const TitleImage = styled.img`
  position: absolute;
  width: 106px;
  top: 0;
  z-index: -1;
  right: -10px;
`;

const Content = styled.div`
  padding: 30px;
  position: relative;
`;

const ImagesContainer = styled.div``;
const Title = styled.h1`
  color: ${primaryColors[0]};
  line-height: 2rem;
`;
const SubTitle = styled.h4`
  color: ${secondaryColors[0]};
`;

const Spacer = styled.div`
  height: 30px;
  width: 30px;
`;

const Image = styled.img<IMedia>`
  width: ${(props) => (props.large ? "45vw" : "100vw")};

  margin-bottom: 50px;
  box-shadow: 20px 19px 0 0 rgb(189 189 189 / 50%);
  border: 1px solid ${secondaryColors[6]};
`;

export default NewsPage;
